import React, { ReactNode } from 'react'

interface IProps {
  onClick: () => void
  isSelected: boolean
  children?: ReactNode
}

export const Item: React.FC<IProps> = ({ children, onClick, isSelected }) => {
  return (
    <ul
      className={ `option ${ isSelected ? 'selected' : '' }` }
      onClick={ onClick }
    >
      <span>{ children }</span>
    </ul>
  )
}
